import {pullRequestsAppBuilder} from '../config/app-builder'
import {mainQuery} from '@github-ui/react-core/future/query-configs'
import type {CommitsRoutePayload} from './route-payload-types'

export const pullRequestsCommitsRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsCommitsRoute', {
  path: '/:owner/:repo/pull/:pr_number/commits',
  queries: [mainQuery<CommitsRoutePayload>({queryDeps: ({pathname}) => ({pathname})})],
})
